import * as React from 'react';
import Button from '@telia-front/button';
import Grid, { GridColumn } from '@telia-front/grid';
import Heading from '@telia-front/heading';
import Icon from '@telia-front/icon';
import Image from '@telia-front/image';
import Separator from '@telia-front/separator';
import { TableCell, TableRow } from '@telia-front/table';
import { TableCollapse, TableCollapseTrigger } from '@telia-front/table-collapse';
import { TvComparisonContext } from './index';
import ChannelPriceTableCell from './channel-price-table-cell';
import MobileTableHeader from './mobile-table-header';
import NecessitiesInfo from './necessities-info';
const MobileChannels = (props) => {
    var _a, _b, _c, _d;
    const { channels, initialHeadingLevel = 2, packets, showLanguages } = props;
    const { showMoreLabel, showLessLabel, soundLabel, subTitlesLabel } = React.useContext(TvComparisonContext);
    const allChannelsShown = channels.channels.length + (((_b = (_a = channels.separatedChannels) === null || _a === void 0 ? void 0 : _a.channels) === null || _b === void 0 ? void 0 : _b.length) || 0) === channels.count;
    const renderSoundAndSubtitles = (channel) => (React.createElement(React.Fragment, null,
        React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
        (channel.sound || channel.subTitles) && (React.createElement("p", { className: "text-small tv-comparison__sound-and-subtitles" },
            channel.sound && (React.createElement(React.Fragment, null,
                React.createElement("strong", null,
                    soundLabel,
                    ":"),
                " ",
                channel.sound,
                React.createElement("br", null))),
            channel.subTitles && (React.createElement(React.Fragment, null,
                React.createElement("strong", null,
                    subTitlesLabel,
                    ":"),
                " ",
                channel.subTitles))))));
    const renderChannelRow = (channel) => {
        return (React.createElement(React.Fragment, { key: channel.id },
            React.createElement(TableRow, { className: "tv-comparison__row" },
                React.createElement(TableCell, { colSpan: 3, className: "tv-comparison__name-cell" },
                    React.createElement(Grid, { noWrap: true, align: ['middle-xs'] },
                        React.createElement(GridColumn, { width: ['min'] },
                            React.createElement(Image, Object.assign({}, channel.image, { shape: "circle", width: 40 }))),
                        React.createElement(GridColumn, { width: ['max'] },
                            React.createElement("p", { className: "h5 text-bold" }, channel.title),
                            channel.exclusiveLabel && (React.createElement(Grid, { noWrap: true, align: ['top-xs'], verticalGutter: "none", gutter: "xsmall" },
                                React.createElement(GridColumn, { width: ['min'] },
                                    React.createElement(Icon, { modifiers: "#star", align: "middle", size: "xxs" })),
                                React.createElement(GridColumn, { width: ['max'] },
                                    React.createElement("span", { className: "text-small" }, channel.exclusiveLabel))))),
                        React.createElement(GridColumn, { width: ['min'] }, showMoreLabel && (React.createElement(TableCollapseTrigger, { text: showMoreLabel, activeText: showLessLabel, url: `#${channel.id}`, iconRight: "#arrow-down", link: true })))),
                    showLanguages && renderSoundAndSubtitles(channel))),
            React.createElement(TableRow, { id: channel.id, collapsible: true, className: "tv-comparison__row" },
                React.createElement(TableCell, { colSpan: 3, className: "text tv-comparison__info-cell tv-comparison__channel-info-cell" },
                    !showLanguages && renderSoundAndSubtitles(channel),
                    (channel.sound || channel.subTitles) && channel.description && (React.createElement(Separator, { spacing: "xsmall", weight: "thin", color: showLanguages ? 'invisible' : undefined })),
                    channel.description && React.createElement("div", null, channel.description),
                    React.createElement(NecessitiesInfo, { content: channel.viewingNecessitiesDescription }))),
            React.createElement(TableRow, { className: "tv-comparison__row tv-comparison__price-row" }, channel.packetPrices.map((price, index) => (React.createElement(ChannelPriceTableCell, { price: price, width: 4, key: index, alignCenter: true }))))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { level: initialHeadingLevel, className: "h4 tv-comparison__header" },
            channels.label,
            channels.count && (React.createElement(React.Fragment, null,
                " ",
                React.createElement("span", { className: "text-light" },
                    "(",
                    channels.count,
                    ")")))),
        React.createElement(TableCollapse, { className: "tv-comparison__table", bordered: true },
            React.createElement("thead", { className: "sr-only" },
                React.createElement(MobileTableHeader, { packets: packets })),
            React.createElement("tbody", null, channels.channels.map(renderChannelRow))),
        ((_d = (_c = channels.separatedChannels) === null || _c === void 0 ? void 0 : _c.channels) === null || _d === void 0 ? void 0 : _d.length) && allChannelsShown && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            channels.separatedChannels.text,
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement(TableCollapse, { className: "tv-comparison__table", bordered: true },
                React.createElement("thead", { className: "sr-only" },
                    React.createElement(MobileTableHeader, { packets: packets })),
                React.createElement("tbody", null, channels.separatedChannels.channels.map(renderChannelRow))))),
        channels.viewAllButton && (React.createElement(React.Fragment, null,
            React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
            React.createElement("p", { className: "text-center" },
                React.createElement(Button, Object.assign({}, channels.viewAllButton)))))));
};
export default MobileChannels;
